module.exports = __webpack_public_path__ + "img/Lipalink-Logo.8efa7fd5.png";